const setHealthCareTeam = (state, healthCareTeamList) => {
  Object.assign(state, { healthCareTeamList })
}

const setLiteProfile = (state, profile) => {
  const displayName = profile?.socialName || profile?.fullName

  const liteProfile = {
    ...profile,
    displayName
  }

  Object.assign(state, {
    profiles: {
      ...state.profiles,
      [liteProfile.personId]: liteProfile
    }
  })
}

const setCaseRecords = (state, caseRecords) => {
  Object.assign(state, {
    caseRecords: {
      ...state.caseRecords,
      [caseRecords.personId]: caseRecords
    }
  })
}

const setHealthEvent = (state, healthEvent) => {
  Object.assign(state, {
    healthEvents: {
      ...state.healthEvents,
      [healthEvent.id]: healthEvent
    }
  })
}

export default {
  setHealthCareTeam,
  setLiteProfile,
  setCaseRecords,
  setHealthEvent
}
